<template>
  <div>
    <div class="fixed-toggle-side-menu">
      <div class="toggle-side-menu" @click="$emit('handleToggleSideMenu')">
        <i class="icon-toggle-side-menu fa fa-caret-left"></i>
        <div class="tooltip-toggle-side-menu"></div>
      </div>
      <div
        v-show="isOpenAnalysisSubmenu"
        class="analysis-submenu"
        :style="{top: `${submenuTop}px`}"
        @mouseenter="cancelCloseSubmenu"
        @mouseleave="scheduleCloseSubmenu"
      >
        <ul>
          <li v-for="sub in analysisSubmenu" :key="sub.seq">
            <router-link :to="{name: 'Analysis', params: {id: sub.seq}}" class="item-menu">
              <span class="nav-label">{{ sub.menuName }}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="sidebar-menu">
      <ul id="menu">
        <template v-for="item in navbars" >
          <li v-if="item.routerName === 'Analysis'"
            :key="item.routerName"
            class="nav01_bg_color"
            :class="{'active': item.activeRouters.includes($route.name)}"
            @mouseenter="openAnalysisSubmenu($event)"
            @mouseleave="scheduleCloseSubmenu"
          >
            <a class="item-menu" @click.stop>
              <div v-html="item.icon"></div>
              <span class="nav-label">{{ item.label }}</span>
            </a>
          </li>

          <li v-else-if="item.routerName === 'Premium'"
            :key="item.routerName"
            class="nav01_bg_color"
            :class="{'active': item.activeRouters.includes($route.name)}"
            :title="item.label"
            >
            <component
              :is="isBasicPlan ? 'a' : 'router-link'"
              :href="isBasicPlan ? 'https://salemon.my.canva.site/premiumplan' : null"
              :to="!isBasicPlan ? {name: item.routerName} : null"
              :target="isBasicPlan ? '_blank' : null"
              class="item-menu"
            >
              <div v-html="item.icon"></div>
              <span class="nav-label">{{ item.label }}</span>
            </component>
          </li>

          <li v-else
            :key="item.routerName"
            class="nav01_bg_color"
            :class="{'active': item.activeRouters.includes($route.name)}"
            :title="item.label"
          >
            <router-link :to="{ name: item.routerName, params: item.params }" class="item-menu">
              <div v-html="item.icon"></div>
              <span class="nav-label">{{ item.label }}</span>
            </router-link>
          </li>
        </template>

        <li class="nav01_bg_color" title="ログアウト">
          <a @click="$emit('doLogout')" class="item-menu">
            <i class="fa fa-sign-out" aria-hidden="true"></i>
            <span class="nav-label">ログアウト</span>
          </a>
        </li>
        <br>
        <li class="nav01_bg_color version-info">
          <p class="text-white text-center">version: {{ appVersion }}</p>
        </li>
      </ul>
      <div class="footer text-center m-b-md">
        <a class="text--underline" :href="downloadUrl" download target="_blank">
          <span>利用規約</span>
        </a>
        <br>
        <a class="text--underline" :href="downloadUrlV2" download target="_blank">
          <span>プライバシーポリシー</span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import navbars from '@/common/sidebar-menu'

export default {
  props: {
    downloadUrl: {
      type: String,
      default: ''
    },
    downloadUrlV2: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      navbars: navbars,
      isOpenAnalysisSubmenu: false,
      submenuTop: 444,
      closeTimer: null
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'getUser',
      analysisSubmenu: 'getAnalysisMenu'
    }),
    appVersion () {
      return this.userInfo.version
    },
    storageSkipShowRegisterInfoName () {
      return `${this.userInfo.sellerId}-SkipShowRegisterInfo`
    },
    storageSideMenuCloseName () {
      return `${this.userInfo.sellerId}-SideMenuClose`
    },
    isBasicPlan () {
      return this.userInfo.memberPlan === '0'
    }
  },
  methods: {
    openAnalysisSubmenu (event) {
      this.isOpenAnalysisSubmenu = true
      const liRect = event.currentTarget.getBoundingClientRect()
      this.submenuTop = liRect.top
      if (this.closeTimer) {
        clearTimeout(this.closeTimer)
        this.closeTimer = null
      }
    },
    scheduleCloseSubmenu () {
      this.closeTimer = setTimeout(() => {
        this.isOpenAnalysisSubmenu = false
      }, 200)
    },
    cancelCloseSubmenu () {
      if (this.closeTimer) {
        clearTimeout(this.closeTimer)
        this.closeTimer = null
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SidebarMenuPageLarge.vue